import { Navigate, Route, createBrowserRouter } from "react-router-dom";
import Home from "./modules/website/Home";
/**ADMIN ROUTE START */
import AdminLayout from "./modules/admin/shared/adminlayout";
import PrivateRoute from "./modules/admin/shared/privateRoute";
import PublicRoute from "./modules/admin/shared/publicRoute";
// import Error404 from "./modules/admin/pages/404";
import Error404 from "./modules/admin/pages/404";
import Dashboard from "./modules/admin/pages/dashboard";
import EmailTemplatesTable from "./modules/admin/pages/cms/automaticemailtemplates/list";
import ExtraActionList from "./modules/admin/pages/extra-actions/list";
import EmailTempAdd from "./modules/admin/pages/cms/automaticemailtemplates/add";
import EmailTempEdit from "./modules/admin/pages/cms/automaticemailtemplates/edit";
import ViewEmailTemp from "./modules/admin/pages/cms/automaticemailtemplates/view";
import PageTable from "./modules/admin/pages/cms/pages/list";
import PageAdd from "./modules/admin/pages/cms/pages/add";
import PageEdit from "./modules/admin/pages/cms/pages/edit";
import PageView from "./modules/admin/pages/cms/pages/view";
import AgreementList from "./modules/admin/pages/cms/agreements/list";
import AddAgreementTemplate from "./modules/admin/pages/cms/agreements/add";
import EditAgreementTemplate from "./modules/admin/pages/cms/agreements/edit";
import ConsentTable from "./modules/admin/pages/cms/consent/list";
import ConsentAdd from "./modules/admin/pages/cms/consent/add";
import ConsentEdit from "./modules/admin/pages/cms/consent/edit";
import ConsentView from "./modules/admin/pages/cms/consent/view";
import WebsiteTable from "./modules/admin/pages/cms/website/list";
import WebsiteAdd from "./modules/admin/pages/cms/website/add";
import WebsiteEdit from "./modules/admin/pages/cms/website/edit";
import WebsiteView from "./modules/admin/pages/cms/website/view";
import GlobalSettings from "./modules/admin/pages/cms/settings/settings";
import BannerTable from "./modules/admin/pages/cms/banners/list";
import BannerAdd from "./modules/admin/pages/cms/banners/add";
import BannerEdit from "./modules/admin/pages/cms/banners/edit";
import BannerView from "./modules/admin/pages/cms/banners/view";
import AdminUnAuthLayout from "./modules/admin/shared/adminUnAuthLayout";

import FaqTable from "./modules/admin/pages/faq/list";
import FaqAdd from "./modules/admin/pages/faq/add";
import FaqEdit from "./modules/admin/pages/faq/edit";
import ContactUsList from "./modules/admin/pages/contact-us/list";
import ViewInquiry from "./modules/admin/pages/contact-us/view";
import EarlyAccessList from "./modules/admin/pages/early-access/list";

import EditProfile from "./modules/admin/pages/admin/editprofile";
import Changepassword from "./modules/admin/pages/admin/changepassword";
import Login from "./modules/admin/pages/auth/login";
import CustomerPortalLogin from "./modules/admin/pages/auth/customer-portal-login";
import ForgotPwdPage from "./modules/admin/pages/auth/forgotpassword";
import OtpVerificationPage from "./modules/admin/pages/auth/otpverification";
import ResetPwdPage from "./modules/admin/pages/auth/resetpwd";
import CompleteAdminProfile from "./modules/admin/pages/admin/completeAdminProfile";
import Profile from "./modules/admin/pages/admin/profile";
import SMSTemplatesTable from "./modules/admin/pages/cms/smsTemplate/list";
import ViewSMSTemp from "./modules/admin/pages/cms/smsTemplate/view";
import SMSTempEdit from "./modules/admin/pages/cms/smsTemplate/edit";
import SMSTempAdd from "./modules/admin/pages/cms/smsTemplate/add";
import ClubAdminList from "./modules/admin/pages/users-management/club-admins/list";
import PlayersList from "./modules/admin/pages/users-management/players/list";
import ViewPlayers from "./modules/admin/pages/users-management/players/view";
import EditPlayers from "./modules/admin/pages/users-management/players/edit";
import ClubAdminEdit from "./modules/admin/pages/users-management/club-admins/edit";
import ClubAdminView from "./modules/admin/pages/users-management/club-admins/view";
import PermissionList from "./modules/admin/pages/permission-management/permission/list";
import RolesList from "./modules/admin/pages/permission-management/roles/list";
import PermissionAdd from "./modules/admin/pages/permission-management/permission/add";
import PermissionView from "./modules/admin/pages/permission-management/permission/view";
import PermissionEdit from "./modules/admin/pages/permission-management/permission/edit";
import RoleAdd from "./modules/admin/pages/permission-management/roles/add";
import RoleEdit from "./modules/admin/pages/permission-management/roles/edit";
import RoleView from "./modules/admin/pages/permission-management/roles/view";
import SubAdminList from "./modules/admin/pages/users-management/sub-admins/list";
import SubAdminAdd from "./modules/admin/pages/users-management/sub-admins/add";
import SubAdminView from "./modules/admin/pages/users-management/sub-admins/view";
import SubAdminEdit from "./modules/admin/pages/users-management/sub-admins/edit";
import FaqView from "./modules/admin/pages/faq/view";
import ParentAdminList from "./modules/admin/pages/users-management/parent-admin/list";
import ParentAdminView from "./modules/admin/pages/users-management/parent-admin/view";
import ParentAdminEdit from "./modules/admin/pages/users-management/parent-admin/edit";

//import basic user
import BasicUserList from "./modules/admin/pages/users-management/basic-user/list";
import BasicUserView from "./modules/admin/pages/users-management/basic-user/view"
import BasicUserEdit from "./modules/admin/pages/users-management/basic-user/edit"
import TeamManagerList from "./modules/admin/pages/users-management/team-managers/list";
import TeamManagerView from "./modules/admin/pages/users-management/team-managers/view";
import AuditLogsList from "./modules/admin/pages/users-management/audit-logs/list";

//import club managament
import ClubManagament from "./modules/admin/pages/club/club-managament/list"
import ClubManagamentDetails from "./modules/admin/pages/club/club-managament/view";
import BillingSnapshot from "./modules/admin/pages/club/club-managament/billing-snapshot";
import ReceiptInvoice from "./modules/admin/pages/club/club-managament/receipt-invoice";
import BillingLogs from "./modules/admin/pages/club/club-managament/billing-logs";
import MatchManagamentList from "./modules/admin/pages/match-managament/list";
import MatchManagamentDetails from "./modules/admin/pages/match-managament/view";
import MatchAdd from "./modules/admin/pages/match-managament/add";
import Team from "./modules/admin/pages/team/list";
import TeamDetails from "./modules/admin/pages/team/view";
import PlayerAdd from "./modules/admin/pages/users-management/players/add";
import PermissionGuard from "./modules/admin/shared/PermissionGuard";
import Errror from "./modules/admin/pages/Errror";
import RawDataPage from "./modules/admin/pages/reports/RawDataPage";
import AboutUs from "./modules/website/AboutUs";
import Faq from "./modules/website/Faq";
import ContactUs from "./modules/website/ContactUs";
import PrivacyPolicy from "./modules/website/PrivacyPolicy";
import TermsCondition from "./modules/website/TermsConditions";
import PrivacyPolicyWebsite from "./modules/website/PrivacyPolicyWebsite";
import DynamicCMSPage from "./modules/website/DynamicCMSPage";


import ClubBillingDashboard from "./modules/admin/pages/club-billing/dashboard";
import TermsConditionsWebsite from "./modules/website/TermsConditionsWebsite";
import NotFound from "./modules/website/NotFound";
// import MatchManagamentList from "./modules/admin/pages/match-managament/list"
import TransactionsList from "./modules/admin/pages/transactions/list";
import SystemLogsList from "./modules/admin/pages/system-logs/list";
import BroadcastPage from "./modules/admin/pages/broadcast";

const RootIndex = () => {
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.includes("portal") || hostname.startsWith("portal.")) {
    return <PublicRoute component={CustomerPortalLogin} />;
  }
  return <Navigate to="/home" replace />;
};

const router = createBrowserRouter([

  /**WEBSITE ROUTE */
  {
    path: "/home",
    element: <Home />,
  }, 
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  
  /** PUBLIC ONBOARDING ROUTES */
  {
    path: "/onboarding/billing",
    element: <ClubBillingDashboard />,
  },
  {
    path: "/onboarding/billing-setup-return",
    element: <ClubBillingDashboard />},
  {
    path: "/terms-and-conditions",
    element: <TermsCondition />,
  },
  {
    path: "/privacy-policy-website",
    element: <PrivacyPolicyWebsite />,
  },
  {
    path: "/terms-and-conditions-website",
    element: <TermsConditionsWebsite />,
  },
  {
    path: "/pages/:slug",
    element: <DynamicCMSPage />,
  },

  /**ADMIN ROUTE START */
  {
    path: "admin",
    element: <PrivateRoute component={AdminLayout} />,
    children: [
      {
        path: "",
        element: <Navigate to={"/admin/dashboard"} />,
      },
      {
        path: "dashboard",
        element: <PrivateRoute component={Dashboard} />,
      },
      {
        path: "transactions/list/:page",
        element: <PrivateRoute component={TransactionsList} />,
      },
      {
      },
      {
        path: "system-logs",
        element: <PrivateRoute component={SystemLogsList} />,
      },
      {
        path: "system-logs/list/:page",
        element: <PrivateRoute component={SystemLogsList} />,
      },

      {
        path: "profile",
        // element: <Profile />,
        element: <PrivateRoute component={Profile} />,
        children: [
          {
            path: "edit/:id",
            // element: <EditProfile />,
            element: <PrivateRoute component={EditProfile} />,
          },
          {
            path: "change-password/:id",
            // element: <Changepassword />,
            element: <PrivateRoute component={Changepassword} />,
          },
        ],
      },

  
  

      {
        path: "cms/faq-management/faq/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={FaqTable} permission="faq-list" />
        } />,
      },

  ,

      {
        path: "cms/faq-management/faq/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={FaqView} permission="faq-view" />
        } />,
      },
  
      {
        path: "cms/faq-management/faq/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={FaqAdd} permission="faq-add" />
        } />,
      },
      {
        path: "cms/faq-management/faq/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={FaqEdit} permission="faq-edit" />
        } />,
      },

    
        /**faq-management/faq route end */
      


      {
        path: "cms/pages/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PageTable} permission="cms-list" />
        } />,
      },

      //cms list changes end


  
      {
        path: "cms/pages/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PageAdd} permission="cms-add" />
        } />,
      },
      // {
      //   path: "cms/pages/:pgno/edit/:id",
      //   element: <PrivateRoute component={PageEdit} />,
      // },
      {
        path: "cms/pages/:pgno/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PageEdit} permission="cms-edit" />
        } />,
      },

      {
        path: "cms/pages/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PageView} permission="cms-view" />
        } />,
      },
      // cms view changes end

      // agreement management start
      {
        path: "cms/agreements/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={AgreementList} permission="agreements-list" />
        } />,
      },
      {
        path: "cms/agreements/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={AddAgreementTemplate} permission="agreements-add" />
        } />,
      },
      {
        path: "cms/agreements/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={EditAgreementTemplate} permission="agreements-edit" />
        } />,
      },
      // agreement management end

      // user consent changes start
      {
        path: "cms/consent/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ConsentTable} permission="consent-list" />
        } />,
      },
      {
        path: "cms/consent/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ConsentAdd} permission="consent-add" />
        } />,
      },
      {
        path: "cms/consent/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ConsentEdit} permission="consent-edit" />
        } />,
      },
      {
        path: "cms/consent/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ConsentView} permission="consent-view" />
        } />,
      },
      // user consent changes end

      // website changes start
      {
        path: "cms/website/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={WebsiteTable} permission="cms-list" />
        } />,
      },
      {
        path: "cms/website/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={WebsiteAdd} permission="cms-add" />
        } />,
      },
      {
        path: "cms/website/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={WebsiteEdit} permission="cms-edit" />
        } />,
      },
      {
        path: "cms/website/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={WebsiteView} permission="cms-view" />
        } />,
      },
      // website changes end

      {
        path: "cms/banner/list/:pgno",
        element: <PrivateRoute component={BannerTable} />,
      },
      {
        path: "cms/banner/add",
        element: <PrivateRoute component={BannerAdd} />,
      },
      {
        path: "cms/banner/:pgno/edit/:id",
        element: <PrivateRoute component={BannerEdit} />,
      },
      {
        path: "cms/banner/view/:id",
        element: <PrivateRoute component={BannerView} />,
      },

   

      {
        path: "cms/settings",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={GlobalSettings} permission="global-settings-view" />
        } />,
      },

 
      {
        path: "cms/default-email-template/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={EmailTemplatesTable} permission="email-templates-list" />
        } />,
      },
     

      {
        path: "cms/default-email-template/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={EmailTempAdd} permission="email-templates-add" />
        } />,
      },

      {
        path: "cms/default-email-template/:pgno/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={EmailTempEdit} permission="email-templates-edit" />
        } />,
      },
    

      {
        path: "cms/default-email-template/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ViewEmailTemp} permission="email-templates-view" />
        } />,
      },


      {
        path: "cms/sms-template/list/:pgno",
        element: <PrivateRoute component={SMSTemplatesTable} />,
      },
      {
        path: "cms/sms-template/add",
        element: <PrivateRoute component={SMSTempAdd} />,
      },
      {
        path: "cms/sms-template/:pgno/edit/:id",
        element: <PrivateRoute component={SMSTempEdit} />,
      },
      {
        path: "cms/sms-template/view/:id",
        element: <PrivateRoute component={ViewSMSTemp} />,
      },

      {
        path: "contact-us/list/:pgno",
        element: <PrivateRoute component={ContactUsList} />,
      },
      {
        path: "contact-us/view/:id",
        element: <PrivateRoute component={ViewInquiry} />,
      },
      {
        path: "early-access/list/:pgno",
        element: <PrivateRoute component={EarlyAccessList} />,
      },




      // {
      //   path: "user-management/parent-admins/list/:pgno",
      //   element: <PrivateRoute component={ParentAdminList} />,
      // },

      {
        path: "user-management/parent-admins/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ParentAdminList} permission="parent-list" />
        } />,
      },


      // {
      //   path: "user-management/parent-admins/:pgno/edit/:id",
      //   element: <PrivateRoute component={ParentAdminEdit} />,
      // },

      {
        path: "user-management/parent-admins/:pgno/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ParentAdminEdit} permission="parent-edit" />
        } />,
      },

      // {
      //   path: "user-management/parent-admins/view/:pgno",
      //   element: <PrivateRoute component={ParentAdminView} />,
      // },

      {
        path: "user-management/parent-admins/view/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ParentAdminView} permission="parent-view" />
        } />,
      },


  
      {
        path: "user-management/club-admins/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ClubAdminList} permission="club-admin-list" />
        } />,
      },
    

      {
        path: "user-management/club-admins/:pgno/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ClubAdminEdit} permission="club-admin-edit" />
        } />,
      },

   

      {
        path: "user-management/club-admins/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ClubAdminView} permission="club-admin-view" />
        } />,
      },


 ,

      {
        path: "user-management/players/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PlayerAdd} permission="players-add" />
        } />,
      },

   

      {
        path: "user-management/players/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PlayersList} permission="players-list" />
        } />,
      },

      {
        path: "user-management/players/:pgno/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={EditPlayers} permission="players-edit" />
        } />,
      },
   

      {
        path: "user-management/players/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ViewPlayers} permission="players-view" />
        } />,
      },

    
      {
        path: "user-management/sub-admins/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={SubAdminList} permission="sub-admin-list" />
        } />,
      },

      {
        path: "user-management/sub-admins/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={SubAdminAdd} permission="sub-admin-add" />
        } />,
      },
    

      {
        path: "user-management/sub-admins/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={SubAdminView} permission="sub-admin-view" />
        } />,
      },
  

      {
        path: "user-management/sub-admins/:pgno/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={SubAdminEdit} permission="sub-admin-edit" />
        } />,
      },

      //basic user started


      {
        path: "user-management/basic-user/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={BasicUserList} permission="basic-user-list" />
        } />,
      },

      {
        path: "user-management/team-managers/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={TeamManagerList} permission="team-manager-list" />
        } />,
      },
      {
        path: "user-management/team-managers/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={TeamManagerView} permission="team-manager-view" />
        } />,
      },
      {
        path: "user-management/audit-logs/:userId",
        element: <PrivateRoute component={AuditLogsList} />,
      },




      {
        path: "user-management/basic-user/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={BasicUserView} permission="basic-user-view" />
        } />,
      },

      // {
      //   path: "user-management/basic-user/edit/:id",
      //   element: <PrivateRoute component={BasicUserEdit} />,
      // },


      {
        path: "user-management/basic-user/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={BasicUserEdit} permission="basic-user-edit" />
        } />,
      },

      {
        path: "user-management/broadcast",
        element: <PrivateRoute component={BroadcastPage} />,
      },
      {
        path: "broadcast",
        element: <PrivateRoute component={BroadcastPage} />,
      },

      // basic user finished


      {
        path: "/admin/club-management/club/list/1",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ClubManagament} permission="club-list" />
        } />,
      },



 
      {
        path: "/admin/club-management/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={ClubManagamentDetails} permission="club-view" />
        } />,
      },
      {
        path: "/admin/club-management/billing-snapshot/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={BillingSnapshot} permission="club-view" />
        } />,
      },
      {
        path: "/admin/club-management/billing-logs/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={BillingLogs} permission="club-view" />
        } />,
      },

      // club managament finished

   

      {
        path: "/admin/match-management/match/list/1",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={MatchManagamentList} permission="match-list" />
        } />,
      },




      {
        path: "/admin/match-management/match/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={MatchManagamentDetails} permission="match-view" />
        } />,
      },
      {
        path: "/admin/match-management/match/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={MatchAdd} permission="match-add" />
        } />,
      },

      //match managament finished

  

      //team started
      // {
      //   path: "/admin/team-management/team/list/1",
      //   element: <PrivateRoute component={Team} />
      // },

      {
        path: "/admin/team-management/team/list/1",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={Team} permission="team-list" />
        } />,
      },

      // {
      //   path: "/admin/team-management/team/view/:id",
      //   element: <PrivateRoute component={TeamDetails} />
      // },
      {
        path: "/admin/team-management/team/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={TeamDetails} permission="team-view" />
        } />,
      },

      //team finished

      // reports started

   
      {
        path: "raw-data-events",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={RawDataPage} permission="team-report" />
        } />,
      },
    

 
      {
        path: "permission-management/permission/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={PermissionList} permission="permissions-list" />
        } />,
      },
      {
        path: "permission-management/permission/pages/add",
        element: <PrivateRoute component={PermissionAdd} />,
      },
      {
        path: "permission-management/permission/:pgno/edit/:id",
        element: <PrivateRoute component={PermissionEdit} />,
      },
      {
        path: "permission-management/permission/view/:id",
        element: <PrivateRoute component={PermissionView} />,
      },

      // {
      //   path: "permission-management/roles/list/:pgno",
      //   element: <PrivateRoute component={RolesList} />,
      // },
      {
        path: "permission-management/roles/list/:pgno",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={RolesList} permission="roles-list" />
        } />,
      },
      // {
      //   path: "permission-management/roles/pages/add",
      //   element: <PrivateRoute component={RoleAdd} />,
      // },
      {
        path: "permission-management/roles/pages/add",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={RoleAdd} permission="roles-add" />
        } />,
      },

   
      {
        path: "permission-management/roles/edit/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={RoleEdit} permission="roles-edit" />
        } />,
      },
   

      {
        path: "permission-management/roles/view/:id",
        element: <PrivateRoute component={() =>
          <PermissionGuard component={RoleView} permission="roles-view" />
        } />,
      },
      // ── Club Admin Billing removed and moved to public onboarding route ──
    ],
  },
  {
    path: "admin",
    element: <AdminUnAuthLayout />,
    children: [
      { path: "login", element: <PublicRoute component={Login} /> },
      {
        path: "forget-password",
        element: <PublicRoute component={ForgotPwdPage} />,
      },
      {
        path: "otp-verification/:token",
        element: <PublicRoute component={OtpVerificationPage} />,
      },
      {
        path: "reset-password",
        // element: localStorage.getItem("validate_string") ? <PrivateRoute component={ResetPwdPage} /> : <Navigate to="/admin/login" />
        element: <PublicRoute component={ResetPwdPage} />,
      },
    ],
  },
  {
    path: "/",
    element: <AdminUnAuthLayout />,
    children: [
      { index: true, element: <RootIndex /> },
      { path: "customer-portal-login", element: <PublicRoute component={CustomerPortalLogin} /> },
    ]
  },
  {
    path: "admin/complete-profile/:validate_string",
    element: <PublicRoute component={CompleteAdminProfile} />,
  },
  {
    path: "view-receipt/:id",
    element: <ReceiptInvoice />,
  },
  {
    path: "admin/club-management/billing-receipt/:id",
    element: <ReceiptInvoice />,
  },
  {
    path: "admin/extra-actions/list",
    element: <PrivateRoute component={ExtraActionList} />,
  },


  { path: "admin/*", element: <Error404 /> },
  { path: "admin/*", element: <Errror /> },
  { path: "*", element: <NotFound /> },
], {
  future: {
    v7_relativeSplatPath: true
  },
});

export default router;
